import { render, staticRenderFns } from "./MendingUpgrades.vue?vue&type=template&id=3bb497cc&scoped=true&"
import script from "./MendingUpgrades.vue?vue&type=script&lang=js&"
export * from "./MendingUpgrades.vue?vue&type=script&lang=js&"
import style0 from "./MendingUpgrades.vue?vue&type=style&index=0&id=3bb497cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb497cc",
  null
  
)

export default component.exports